export const SET_NAVIGATOR_TITLE = 'SET_NAVIGATOR_TITLE'
export const SET_NAVIGATOR_LINKS = 'SET_NAVIGATOR_LINKS'
export const SET_STATUS_FINEPLAY = 'SET_STATUS_FINEPLAY'
export const TOOGLE_FINEPLAY_SCREEN_CHAT = 'TOOGLE_FINEPLAY_SCREEN_CHAT'



// WEBPACK FOOTER //
// ./src/store/modules/navigator/mutation-types.js